import request from "@/utils/request";


export function updateReturnVisit(data){
  return request({
    url: "/client/updatareturnvisit",
    method: "post",
    data
  })
}

export function searchPotentialClientsHistory(data) {
  return request({
    url: "/client/searchmypclienthistory",
    method: "get",
    params: data
  });
}

export function getPotentialClientsSchool(data) {
  return request({
    url: "/client/getpotentialclientsschool",
    method: "get",
    params: data
  });
}
export function newRechargeRefund(data) {
    return request({
        url: "/client/newrechargerefund",
        method: "post",
        data
    });
}
export function getClientDetail(data) {
    return request({
        url: "/client/getclientdetail",
        method: "get",
        params: data
    });
}


export function newClientReceived(data) {
  return request({
    url: '/client/newreceived',
    method: 'post',
    data
  })
}

export function getClientRechargeList(data) {
  return request({
    url: "/client/getclientrecharge",
    method: "get",
    params: data
  });
}

export function  getClientPayUrl(data) {
  return request({
    url: '/payment/getclientpaymenturl',
    method: 'post',
    data
  })
}

export function getMyReturnVisitList(data) {
  return request({
    url: '/client/getmyreturnvisitlist',
    method: 'post',
    data
  })
}
export function newReturnVisit(data) {
  return request({
    url: '/client/newreturnvisit',
    method: 'post',
    data
  })
}


export function getMyClientCalendar(params) {
  return request({
    url: '/client/getmyclientcalendar',
    method: 'get',
    params
  })
}

export function updataClientDetail(data) {
  return request({
    url: '/client/updataclientdetail',
    method: 'post',
    data
  })
}

export function newClientDetail(data) {
  return request({
    url: '/client/newclientdetail',
    method: 'post',
    data
  })
}

export function updataClientTag(data) {
  return request({
    url: '/client/updataclienttag',
    method: 'get',
    params:data
  })
}

export function getMyClients(params) {
  return request({
    url: '/client/getmyclients',
    method: 'get',
    params:params
  })
}

export function getRecpClients(data) {
  return request({
    url: '/client/recpclients',
    method: 'get',
    params:data
  })
}




export function setPclientState(data) {
  return request({
    url: '/client/setpclientstate',
    method: 'get',
    params:data
  })
}


export function uploadClientsData(data) {
  return request({
    url: '/client/uploadclientsdata',
    method: 'post',
    data
  })
}


export function getClientsData(data) {
  return request({
    url: '/client/getpclientsdata',
    method: 'get',
    params:data
  })
}



export function adoptClient(data) {
  return request({
    url: '/client/adoptclient',
    method: 'get',
    params:data
  })
}
export function getAdoptClients(params) {
  return request({
    url: '/client/getmypclients',
    method: 'get',
    params
  })
}


export function updataPclientMajor(data) {
  return request({
    url: '/client/updatapclientmajor',
    method: 'get',
    params:data
  })
}
